const MESSAGES = {
  invalid_credentials: "Incorrect email or password.",
  email_not_confirmed: "Please verify your email before signing in.",
  over_request_rate_limit: "Too many attempts. Please wait a moment and try again.",
  over_email_send_rate_limit: "Too many attempts. Please wait a moment and try again.",
  weak_password: "Choose a stronger password (at least 8 characters, hard to guess).",
  same_password: "Your new password must be different from your current one.",
  otp_expired: "This link has expired or was already used.",
  session_not_found: "Your session has ended. Please sign in again.",
  reauthentication_needed: "Please sign in again before changing your password.",
};

export function authErrorMessage(error) {
  if (!error) return "";
  if (error.code && MESSAGES[error.code]) return MESSAGES[error.code];
  if (error.status === 0 || /fetch/i.test(error.message || "")) return "Can't reach ChatSleek. Check your connection and try again.";
  return error.message || "Something went wrong. Please try again.";
}
